import React, { useState } from 'react';
import styled from '@emotion/styled';
import { IconButton, Tooltip } from '@material-ui/core';
import { FileCopyOutlined } from '@material-ui/icons';
import { css } from '@emotion/react';
import { greys } from '@/styles/colors';

export const SubListBlock = styled.div`
    margin-top: 0.75rem;
`;

export const PricingBlock = styled.div`
    padding: 0.75rem;
    margin-bottom: 1rem;
    border: 1px solid #e2e2e2;
    border-radius: 4px;
`;

export const FieldRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 0.5rem;
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 140px;
`;

export const ChipRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
`;

export const ConfigGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 0.5rem;
`;

export const EditActions = styled.div`
    display: flex;
    gap: 0.5rem;
    margin-top: 0.75rem;
`;

export const CopyableCell = ({ value }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = (e) => {
        e?.stopPropagation?.();
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    if (!value || value === '--') return <span>{value || '--'}</span>;

    return (
        <Tooltip title={copied ? 'Copied!' : value} placement="top">
            <span
                css={css`
                    display: flex;
                    align-items: center;
                    gap: 0.25rem;
                    min-width: 0;
                `}
            >
                <span
                    css={css`
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        flex: 1;
                        min-width: 0;
                    `}
                >
                    {value}
                </span>
                <IconButton size="small" onClick={handleCopy}>
                    <FileCopyOutlined
                        css={css`
                            font-size: 13px;
                            color: #8d8d8d;
                        `}
                    />
                </IconButton>
            </span>
        </Tooltip>
    );
};

// `&&` doubles the class so it outranks the scoped `.onward-design button` reset (0,1,1).
const CopyablePill = styled.button`
    && {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.2rem 0.55rem;
        border: 1px solid ${greys.border};
        border-radius: 4px;
        background: #fff;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        color: ${greys.secondary};
        line-height: 1.4;
        transition: background-color 120ms ease, border-color 120ms ease;

        &:hover {
            background: ${greys.selected};
            border-color: ${greys.primary};
        }

        &:focus-visible {
            outline: 2px solid ${greys.primary};
            outline-offset: 1px;
        }
    }
`;

export const CopyableId = ({ label, value }) => {
    const [copied, setCopied] = useState(false);

    if (!value || value === '--') return <span>{value || '--'}</span>;

    const handleCopy = (e) => {
        e?.stopPropagation?.();
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    const tip = copied ? 'Copied!' : label ? `Copy ${label}` : 'Copy';

    return (
        <Tooltip title={tip} placement="top">
            <CopyablePill type="button" onClick={handleCopy}>
                <FileCopyOutlined
                    css={css`
                        font-size: 13px;
                        color: ${greys.primary};
                    `}
                />
                <span>{value}</span>
            </CopyablePill>
        </Tooltip>
    );
};
